import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstancezyao53u70tqo as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.plugins_1.containsKey_aw81wo_k$(plugin.get_key_18j28a_k$()))
    return Unit_instance;
  var tmp0 = $this.plugins_1;
  var tmp2 = plugin.get_key_18j28a_k$();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.attributes_1.computeIfAbsent_c4qp5i_k$(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.config_1.pluginConfigurations_1.get_wei43m_k$(plugin.get_key_18j28a_k$()));
    var pluginData = plugin.prepare_t1xtpw_k$(config);
    plugin.install_zd7cej_k$(pluginData, scope);
    attributes.put_gkntno_k$(plugin.get_key_18j28a_k$(), pluginData);
    return Unit_instance;
  };
  tmp0.put_4fpzoq_k$(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.plugins_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.pluginConfigurations_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.customInterceptors_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_2 = this;
        tmp_2.engineConfig_1 = HttpClientConfig$engineConfig$lambda;
        this.followRedirects_1 = true;
        this.useDefaultTransformers_1 = true;
        this.expectSuccess_1 = false;
        this.developmentMode_1 = PlatformUtils_getInstance().IS_DEVELOPMENT_MODE_1;
      }
      install_6m4asv_k$(plugin, configure) {
        var previousConfigBlock = this.pluginConfigurations_1.get_wei43m_k$(plugin.get_key_18j28a_k$());
        var tmp0 = this.pluginConfigurations_1;
        var tmp2 = plugin.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.put_4fpzoq_k$(tmp2, value);
        installPlugin(this, plugin);
      }
      install$default_lc5jjj_k$(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.install_6m4asv_k$(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.install_6m4asv_k$.call(this, plugin, configure);
        }
        return tmp_0;
      }
      install_vucysr_k$(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.customInterceptors_1.put_4fpzoq_k$(key, block);
      }
      install_se0ieo_k$(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.plugins_1.get_values_ksazhn_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.customInterceptors_1.get_values_ksazhn_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      plusAssign_xm1izo_k$(other) {
        this.followRedirects_1 = other.followRedirects_1;
        this.useDefaultTransformers_1 = other.useDefaultTransformers_1;
        this.expectSuccess_1 = other.expectSuccess_1;
        var tmp0 = this.plugins_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.plugins_1;
        tmp0.putAll_wgg6cj_k$(map);
        var tmp0_0 = this.pluginConfigurations_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.pluginConfigurations_1;
        tmp0_0.putAll_wgg6cj_k$(map_0);
        var tmp0_1 = this.customInterceptors_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.customInterceptors_1;
        tmp0_1.putAll_wgg6cj_k$(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
